import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { config } from '../../config';
import { SidebarContext } from '../../context/SidebarContext';
import { useContext } from 'react';
import { useThemeMode } from '../../context/ThemeContext';
import './Navbar.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FiMoon, FiSun } from 'react-icons/fi';
function Navbar() {
    const { frontEndBaseUrl } = config;
    const { toggle, isSidebar } = useContext(SidebarContext);
    const { isDarkMode, toggleTheme } = useThemeMode();
    const [userImage] = useState('https://upload.wikimedia.org/wikipedia/commons/9/99/Sample_User_Icon.png?20200919003010');
    const [visible, setVisible] = useState(false);
    const dropdownRef = useRef(null);

    const adminRole = localStorage.getItem("adminRole");
    const adminCity = adminRole === "sub-admin" ? localStorage.getItem("adminCity") : null;
    const nextThemeLabel = isDarkMode ? "light" : "dark";

    const handleLogout = async () => {
        localStorage.removeItem('authToken');
        try {
            const response = await fetch(`${config.backEndBaseUrl}admin/signOut`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            const json = await response.json()




            if (json.status) {
                localStorage.removeItem('adminToken');
                localStorage.removeItem('adminUserId');
                localStorage.removeItem('adminRole');
                localStorage.removeItem('subAdmin');
                localStorage.removeItem('adminCity');
                toast.success(json.message, {
                    position: 'top-right',
                });
                setTimeout(() => {
                    window.location.href = '/';
                }, 1000)
            } else {
                console.log('Login failed:', json.message); // Debug log
                toast.error('Cannot Logout', {
                    position: 'top-right',
                });
            }
        } catch (err) {
            console.log(err)
            toast.error('Internal server Error', {
                position: 'top-right',
            });
        }
    };



    // Handle clicks outside of the dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <ToastContainer />
            <div className="header-dashboard" style={{ width: isSidebar ? 'calc(100% - 280px)' : '100%' }}>
                <div className="wrap">
                    <div className="header-left">
                        <Link to="/" style={{ display: isSidebar ? 'none' : 'block' }}>
                            <img className="" id="logo_header_mobile" alt="logo_header" src={`${frontEndBaseUrl}adminAssets/images/payLogo.jpg`} />
                        </Link>
                        <div className="button-show-hide" style={{ display: isSidebar ? 'none' : 'block' }} onClick={toggle}>
                            <i className="icon-menu-left"></i>
                        </div>
                    </div>

                    <div className="header-grid">
                        <button
                            type="button"
                            className="theme-toggle-button"
                            onClick={toggleTheme}
                            aria-label={`Switch to ${nextThemeLabel} mode`}
                            title={`Switch to ${nextThemeLabel} mode`}
                        >
                            <span className="theme-toggle-icon" aria-hidden="true">
                                {isDarkMode ? <FiSun /> : <FiMoon />}
                            </span>
                            {/* <span className="theme-toggle-copy">
                                <span className="theme-toggle-label">Theme</span>
                                <span className="theme-toggle-value">{isDarkMode ? "Dark" : "Light"}</span>
                            </span> */}
                        </button>

                        <div className="popup-wrap user type-header" ref={dropdownRef}>
                            <div className="dropdown">
                                <button
                                    className="btn btn-secondary dropdown-toggle"
                                    type="button"
                                    onClick={() => setVisible(!visible)}
                                >
                                    <span className="header-user wg-user">
                                        <span className="image">
                                            <img src={`${userImage}`} className="userImage" alt="avatar_img" />
                                        </span>
                                        <span className="flex flex-column">
                                            <span className="body-title mb-2 uppercase">{adminRole}</span>
                                            {adminCity && <span className="body-title-2 mb-2">{adminCity}</span>}
                                        </span>
                                    </span>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end has-content" style={{ display: visible ? 'flex' : 'none', width: "max-content" }} id="drop_menu">
                                    <li>
                                        <Link to="" className="user-item" onClick={() => { handleLogout() }}>
                                            <div className="icon">
                                                <i className="icon-log-out"></i>
                                            </div>
                                            <div className="body-title-2">Log out</div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Navbar;
